import ClaudiaTakeoversAPI from 'dashboard/api/claudiaTakeovers';
import ClaudiaTakeoverBatchesAPI from 'dashboard/api/claudiaTakeoverBatches';

export const actions = {
  async create(_, { conversationIds }) {
    const response = await ClaudiaTakeoversAPI.bulk(conversationIds);
    return response.data;
  },
  async fetch(_, batchId) {
    const response = await ClaudiaTakeoverBatchesAPI.show(batchId);
    return response.data;
  },
  async retryFailed(_, batchId) {
    const response = await ClaudiaTakeoverBatchesAPI.retryFailed(batchId);
    return response.data;
  },
};

export default {
  namespaced: true,
  actions,
};
